import { useState } from 'react';

export const useModal = () => {
  const [showModal, setShowModal] = useState(false);
  return {
    closeModal: () => {
      setShowModal(false);
    },
    openModal: () => setShowModal(true),
    show: showModal,
  };
};
